import { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import ModalConferma from "../../Utilities/ModalConferma";
import ImpostazioniComuneService from "../../../services/ImpostazioniComuneService";

export default function ImpostazioniModuli(props) {

    //Stati per l'attivazione dei vari moduli per il comune
    let [imcModuloPetizioniAttivo, setImcModuloPetizioniAttivo] = useState(false)
    let [imcModuloReferendumAttivo, setImcModuloReferendumAttivo] = useState(false)
    let [imcModuloSegnalazioniAttivo, setImcModuloSegnalazioniAttivo] = useState(false)
    let [imcModuloBilanciAttivo, setImcModuloBilanciAttivo] = useState(false)
    let [imcModuloIniziativeAttivo, setImcModuloIniziativeAttivo] = useState(false)
    //Stati per l'attivazione del modulo sondaggio (aggiunto successivamente)
    let [imcModuloSondaggiAttivo, setImcModuloSondaggiAttivo] = useState(false)
    // Stati per la gestione della visibilità dei modali di notifica
    const [mostraModalOk, setMostraModalOk] = useState(false) // Modal di conferma salavataggio
    const [mostraModalFailed, setMostraModalFailed] = useState(false) // Modal di errore
    const [mostraModalCancelOk, setMostraModalCancelOk] = useState(false) // Modal di conferma annullamento

    useEffect(() => {
        // useEffect che imposta gli stati in base ai valori presenti nel database.
        // I valori vengono letti dall'oggetto 'props.comune.impostazioniComune' se presenti, altrimenti vengono inizializzati a 0 (falso).
        setImcModuloPetizioniAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloPetizioniAttivo) || 0)
        setImcModuloReferendumAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloReferendumAttivo) || 0)
        setImcModuloSegnalazioniAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSegnalazioniAttivo) || 0)
        setImcModuloBilanciAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloBilanciAttivo) || 0)
        setImcModuloIniziativeAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloIniziativeAttivo) || 0)
        setImcModuloSondaggiAttivo((props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSondaggiAttivo) || 0)
    }, [props.comune]) // Il codice si esegue ogni volta che cambia `props.comune`.

    /**
    * Mostra il modal di conferma per l'aggiornamento delle impostazioni.
     */
    const preparaSalva = () => {
        setMostraModalCancelOk(true)
    }

    /**
    * Funzione asincrona che salva le impostazioni aggiornate nel database.
     * 
     * - Prepara un oggetto con le nuove impostazioni.
    * - Effettua una chiamata API per aggiornarle nel database.
     * - Gestisce le risposte e mostra i modali di successo o fallimento.
     *      */
    const salvaImpostazioni = async () => {
        let successSaved = false // Flag per indicare se il salvataggio è avvenuto con successo

        // Creazione dell'oggetto contenente le impostazioni aggiornate
        let impostazioni = {
            ...props.comune.impostazioniComune,
            imcModuloPetizioniAttivo: imcModuloPetizioniAttivo,
            imcModuloReferendumAttivo: imcModuloReferendumAttivo,
            imcModuloSegnalazioniAttivo: imcModuloSegnalazioniAttivo,
            imcModuloBilanciAttivo: imcModuloBilanciAttivo,
            imcModuloIniziativeAttivo:imcModuloIniziativeAttivo,
            imcModuloSondaggiAttivo:imcModuloSondaggiAttivo,
            comune: props.comune // Associa il comune alle impostazioni
        }

        // Nasconde il modal di conferma annullamento
        setMostraModalCancelOk(false)

        try {
            // Effettua una richiesta al servizio per aggiornare le impostazioni nel database
            let response = await ImpostazioniComuneService.aggiornaImpostazioni(impostazioni)
            if (response.status === 200) {
                successSaved = true // Il salvataggio è andato a buon fine
                props.setRicaricaComune(true) // Ricarica le informazioni del comune aggiornate
            } else if (response.status === 500)
                //CHECK: prima era messo a false, controllare se è giusto mettere invece true come adesso
                setMostraModalFailed(true)  // Mostra il modal di errore
        } catch (err) {
            setMostraModalFailed(false) // Mostra il modal di errore in caso di eccezione
        }

        // Se il salvataggio è andato a buon fine, mostra il modal di conferma
        if (successSaved)
            setMostraModalOk(true)
    }

    /**
     * Chiude il modal di conferma salvataggio.
    */
    const closeOkModal = () => {
        setMostraModalOk(false)
    }

    /**
     * Chiude il modal di errore.
     */
    const closeOkFailed = () => {
        setMostraModalFailed(false)
    }

    return (
        <>
            <Form>
                <Row className="d-flex">
                    <Col>
                        <Form.Label column>
                            <strong>Attivazione moduli</strong>
                        </Form.Label>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                        <Form.Label column sm="4">
                        Petizioni:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-petizioni"
                                    className="inline mx-2"
                                    checked={imcModuloPetizioniAttivo}
                                    onChange={(ev) => {
                                        setImcModuloPetizioniAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                                </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4">
                                Referendum:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-petizioni"
                                    className="inline mx-2"
                                    checked={imcModuloReferendumAttivo}
                                    onChange={(ev) => {
                                        setImcModuloReferendumAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4">
                                Segnalazioni:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-petizioni"
                                    className="inline mx-2"
                                    checked={imcModuloSegnalazioniAttivo}
                                    onChange={(ev) => {
                                        setImcModuloSegnalazioniAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4">
                                Bilanci partecipativi:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-petizioni"
                                    className="inline mx-2"
                                    checked={imcModuloBilanciAttivo}
                                    onChange={(ev) => {
                                        setImcModuloBilanciAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4">
                                Iniziative:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-iniziative"
                                    className="inline mx-2"
                                    checked={imcModuloIniziativeAttivo}
                                    onChange={(ev) => {
                                        setImcModuloIniziativeAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 mb-md-0">
                    <Col>
                        <Form.Group as={Row}>
                            <Form.Label column sm="4">
                                Sondaggi:
                            </Form.Label>
                            <Col xs={6}>
                                <Form.Label className="small">No</Form.Label>
                                <Form.Check
                                    type="switch"
                                    id="attiva-sondaggi"
                                    className="inline mx-2"
                                    checked={imcModuloSondaggiAttivo}
                                    onChange={(ev) => {
                                        setImcModuloSondaggiAttivo(ev.target.checked)
                                    }}
                                />
                                <Form.Label className="small">Sì</Form.Label>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
            <Container className="d-flex justify-content-end w-90 p-0 pt-5">
                <Button onClick={preparaSalva}>Aggiorna</Button>
            </Container>

            <ModalConferma
                mostra={mostraModalOk}
                setMostra={setMostraModalOk}
                mode="success"
                titolo="Salvataggio impostazioni"
                messaggio="Impostazioni salvate con successo"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={closeOkModal}
            />

            <ModalConferma
                mostra={mostraModalFailed}
                setMostra={setMostraModalFailed}
                mode="error"
                titolo="Salvataggio impostazioni"
                messaggio="Errore nel salvataggio delle impostazioni"
                bodyAlign="text-center"
                btnConferma="Chiudi"
                azioneConferma={closeOkFailed}
            />

            <ModalConferma
                mostra={mostraModalCancelOk}
                setMostra={setMostraModalCancelOk}
                mode="primary"
                titolo="Salvataggio impostazioni"
                messaggio="Confermi il salvataggio delle impostazioni?"
                bodyAlign="text-center"
                btnAnnulla="No, annulla"
                btnConferma="Sì, salva"
                azioneConferma={salvaImpostazioni}
            />
        </>
    )
}